import React, { Component } from 'react';
import { Container, Row, Col, Button, Modal } from 'react-bootstrap';  
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app
 

function Images(props){
    const content = props.itemImages.map((itemImage)=>  <div key={itemImage.id} className="item_details_mini_holder">
        <img  className="item_details_mini_img" src={itemImage.imageURL} alt="cat-" /> 
        </div>
    );
    
    return (<div className="item_details_div">  {content}  </div>);
}

 

class Item extends Component {

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  fullScreenImage(){  
    /*alert("hi from alert")*/
  }
  constructor(props, context) {
   

    super(props, context); 

    

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {  
      photoIndex: 0,
      isOpen: false,
      show: false, 
      item :props.item,
      app :props.app,
      itemImages: [] }
    this.imagesDB =  this.state.app.database().ref().child('images');
    console.log(this.state.item.images);
  }

  componentDidMount() { 
    let images = []
          this.imagesDB.child(this.state.item.id).on('value', snap => {
            let imagesConst = snap.val();
            
            images.push({
              bio: this.state.item.bio,
              id: this.state.item.id,
              imageURL: this.state.item.imageURL,
              ownerID: this.state.item.id,
              uploadDate: this.state.item.uploadDate,
              uploadUser: this.state.item.uploadUser
            } 
            ); 
            
            for (let i in imagesConst) { 
              images.push({
                bio: imagesConst[i].bio,
                id: imagesConst[i].id,
                imageURL: imagesConst[i].imageURL,
                ownerID: imagesConst[i].ownerID,
                uploadDate: imagesConst[i].uploadDate,
                uploadUser: imagesConst[i].uploadUser
              } 
              ); 
            }
            images = images.slice(0,4);
            // console.log(images);
             this.setState({    itemImages : images   });    
            }); 
            
  }


  render() {
    const { photoIndex, isOpen } = this.state;
    return ( 
      <Col key={this.state.item.id}  lg={3} sm={6} >
      <div className="item_div">
        <div className="item_img_holder">
          <img className="item_img" src={this.state.item.imageURL} alt="cat2" /> 
        <Button className="items_btn" onClick={this.handleShow}> Details </Button>
        </div>
      </div>
      <div className="item_details">
        <h5>Code {this.state.item.code} </h5>
        <p className="price_unit"> <span className="price" >   {this.state.item.websitePrice} </span> L.E   <span className="like"><img src="img/icon-heart-01.png" alt="like" /></span> </p>
      </div>
      <Modal className="modal_item"  show={this.state.show} onHide={this.handleClose} size="xl" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton>
            <Modal.Title>Item Details</Modal.Title>
          </Modal.Header>
          <Container>
            <Row>
              <Col lg={6} sm={12} className="items_details_images">
                <Row>
                  <Col xl={2} lg={2} md={3} sm={2} xs={2} >
                    
                      <Images itemImages={this.state.itemImages} /> 
                    
                  </Col>

                  <Col xl={10} lg={10} md={8} sm={9} xs={9} className="fit" >
                    <div className="item_details_div">
                      <div className="item_details_holder">
                        <img  className="item_details_img" src={this.state.item.imageURL} alt="cat-" onClick={() => this.setState({ isOpen: true })} />
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col lg={6} sm={12} >
                <div className="item_details_div">
                  <div className="item_details_desc">
                    <h3> Code {this.state.item.code}</h3>
                    <p className="price"> {this.state.item.websitePrice}L.E</p>
                    <p  >  {this.state.item.name} </p>
                  </div>
                </div>
              </Col>



            </Row>
          </Container>
          <Modal.Footer  >
            <Button variant="secondary" onClick={this.handleClose}>
              Close
            </Button> 
          </Modal.Footer>
        </Modal>

        {isOpen && (
          <Lightbox
            mainSrc={this.state.itemImages[photoIndex].imageURL}
            nextSrc={this.state.itemImages[(photoIndex + 1) % this.state.itemImages.length].imageURL}
            prevSrc={this.state.itemImages[(photoIndex + this.state.itemImages.length - 1) % this.state.itemImages.length].imageURL}
            onCloseRequest={() => this.setState({ isOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + this.state.itemImages.length - 1) % this.state.itemImages.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % this.state.itemImages.length,
              })
            }
          />
        )}

    </Col> 
    );
  }
}

export default Item;
